import { JWT_TOKEN_COOKIE_NAME } from './constants';

export const getCookie = (cookieName: string): string => {
  if (typeof document === 'undefined') {
    return '';
  }

  const name = `${cookieName}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const cookiesArray = decodedCookie.split(';');

  for (let index = 0; index < cookiesArray.length; index += 1) {
    let currentCookie = cookiesArray[index];
    while (currentCookie.charAt(0) === ' ') {
      currentCookie = currentCookie.substring(1);
    }

    if (currentCookie.indexOf(name) === 0) {
      return currentCookie.substring(name.length, currentCookie.length);
    }
  }

  return '';
};

export const setCookie = (name: string, value: string | number): void => {
  if (typeof document !== 'undefined') {
    document.cookie = `${name}=${value};path=/`;
  }
};

export const deleteCookie = (cookieName: string): void => {
  if (typeof document !== 'undefined') {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
  }
};

export const getJWTToken = (): string => {
  const cookieToken = getCookie(JWT_TOKEN_COOKIE_NAME);
  return cookieToken || '';
};
